<script setup lang="ts">
defineOptions({
  name: 'DoubleRightIcon',
});
</script>

<template>
  <svg
    class="DoubleRightIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.875 6.35003L18.525 12L12.875 17.65L11.825 16.6L16.4 12L11.825 7.40002L12.875 6.35003ZM6.52502 6.35003L12.175 12L6.52502 17.65L5.47503 16.6L10.05 12L5.47503 7.40002L6.52502 6.35003Z"
    />
  </svg>
</template>

<style lang="scss" scoped>
.DoubleRightIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
